export const topics = [
  {
    id: "xuanxiu-contract",
    title: "选秀节目选手合约风波",
    category: "综艺",
    status: "持续更新中",
    summary:
      "某新人选秀节目播出后，选手与经纪公司之间的合约条款被陆续曝光，从分成比例到解约赔偿，折射出新人艺人在签约阶段的普遍困境。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20stage%20spotlight%20with%20deep%20crimson%20smoke%20and%20empty%20microphone%20stand%2C%20moody%20editorial%20photography%2C%20abstract%20theatrical%20atmosphere%2C%20dark%20warm%20tones&width=1200&height=800&seq=topic-xuanxiu-01&orientation=landscape",
    heat: 986420,
    updateCount: 17,
    lastUpdate: "2小时前",
    tags: ["新人艺人", "经纪合约", "分成比例"],
    highlights: [
      "签约前口头承诺与实际合同条款存在明显出入，多名选手表示事前并未看到完整文本。",
      "争议集中在经纪分成比例与解约赔偿金额，双方对数字给出了不同解释。",
      "节目制作方回应称已介入协调，但未公布具体处理方案。",
    ],
    timeline: [
      { date: "09-02", title: "节目收官", detail: "节目总决赛播出，选手话题度迅速攀升。" },
      { date: "09-04", title: "条款流出", detail: "有网友整理出疑似合约截图，分成比例引发讨论。" },
      { date: "09-06", title: "选手回应", detail: "数名选手在个人账号表示正在与公司沟通。" },
      { date: "09-08", title: "公司声明", detail: "经纪公司发布声明，称合同签订过程合规。" },
      { date: "09-10", title: "继续发酵", detail: "更多从业者分享签约经验，讨论延伸至行业惯例。" },
    ],
    relatedIds: ["shorts-wage", "dj-club-transfer", "livestream-return"],
  },
  {
    id: "livestream-return",
    title: "直播带货退货潮事件",
    category: "直播",
    status: "持续更新中",
    summary:
      "一场号称全网最低价的直播专场在结束后出现大量退货，消费者反映实际到手价格与宣传不符，商家与主播团队之间也产生了费用争议。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20ring%20light%20glow%20in%20dark%20studio%20with%20warm%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20soft%20haze%2C%20no%20people&width=1200&height=800&seq=topic-live-02&orientation=landscape",
    heat: 874310,
    updateCount: 12,
    lastUpdate: "4小时前",
    tags: ["带货", "退货", "价格争议"],
    highlights: [
      "消费者集中反馈同一商品在其它渠道价格更低，宣传话术与实际不符。",
      "商家表示退货率异常，要求主播团队承担部分坑位费用。",
      "平台方已介入，暂未公布具体处理结果。",
    ],
    timeline: [
      { date: "09-01", title: "专场开播", detail: "专场直播吸引大量观众，多款商品售罄。" },
      { date: "09-03", title: "退货增多", detail: "社交平台出现大量比价与退货讨论。" },
      { date: "09-05", title: "商家发声", detail: "部分商家晒出后台数据，称退货率远超预期。" },
      { date: "09-07", title: "团队回应", detail: "主播团队表示价格由多方共同确认。" },
      { date: "09-09", title: "平台介入", detail: "平台客服称已收到相关反馈并启动核查。" },
    ],
    relatedIds: ["xuanxiu-contract", "restaurant-safety", "travel-blogger"],
  },
  {
    id: "shorts-wage",
    title: "短剧剧组欠薪争议",
    category: "影视",
    status: "持续更新中",
    summary:
      "数个短剧剧组被曝存在延期结算的情况，涉及场务、化妆、群演等多个工种。短剧行业高速扩张背后的资金与用工问题随之浮出水面。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20clapperboard%20and%20camera%20on%20dark%20table%20with%20warm%20amber%20rim%20light%2C%20moody%20editorial%20product%20photography%2C%20abstract%20cinematic%20scene&width=1200&height=800&seq=topic-shorts-03&orientation=landscape",
    heat: 762180,
    updateCount: 9,
    lastUpdate: "6小时前",
    tags: ["短剧", "欠薪", "剧组"],
    highlights: [
      "多位从业者表示部分项目尾款结算周期被反复拉长。",
      "短剧项目周期短、团队临时化，导致权责界定困难。",
      "已有行业协会表示将推动建立更清晰的结算规范。",
    ],
    timeline: [
      { date: "08-28", title: "集中爆料", detail: "多位剧组工作人员在社交平台反映结算问题。" },
      { date: "08-30", title: "制作方回应", detail: "有制作方称资金已进入流程，需等待平台结算。" },
      { date: "09-03", title: "行业讨论", detail: "短剧从业者讨论项目制用工的普遍风险。" },
      { date: "09-06", title: "协会表态", detail: "相关协会表示将推动结算规范的建立。" },
    ],
    relatedIds: ["xuanxiu-contract", "scriptmurder-copy", "festival-ticket"],
  },
  {
    id: "festival-ticket",
    title: "音乐节票务退改争议",
    category: "演出",
    status: "已平息",
    summary:
      "一场户外音乐节因天气原因临时调整演出顺序，部分观众要求退票，主办方与票务平台就退改规则给出了不同说法。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20outdoor%20concert%20stage%20at%20dusk%20with%20warm%20amber%20stage%20lights%20and%20haze%2C%20abstract%20atmospheric%20photography%2C%20no%20people&width=1200&height=800&seq=topic-festival-04&orientation=landscape",
    heat: 521760,
    updateCount: 6,
    lastUpdate: "1天前",
    tags: ["音乐节", "退票", "票务"],
    highlights: [
      "演出顺序调整后，部分观众的出行计划受到影响。",
      "退改规则在购票页面位置较深，引发知情权讨论。",
      "最终主办方公布了分批退款方案，事件逐渐平息。",
    ],
    timeline: [
      { date: "08-20", title: "现场调整", detail: "受天气影响，演出顺序临时变动。" },
      { date: "08-21", title: "观众反馈", detail: "观众在社交平台讨论退票诉求。" },
      { date: "08-24", title: "主办回应", detail: "主办方说明调整原因并表示可申请退款。" },
      { date: "08-27", title: "方案落地", detail: "退款方案公布，事件基本平息。" },
    ],
    relatedIds: ["shorts-wage", "livestream-return", "restaurant-safety"],
  },
  {
    id: "restaurant-safety",
    title: "网红餐厅后厨争议",
    category: "消费",
    status: "持续更新中",
    summary:
      "一家长期排队的网红餐厅被曝后厨管理问题，随后店家公开致歉并暂停营业整改，关于排队文化与餐饮体验的讨论也随之升温。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20modern%20restaurant%20kitchen%20counter%20with%20warm%20ambient%20lighting%2C%20clean%20editorial%20interior%20photography%2C%20neutral%20warm%20tones%2C%20no%20people&width=1200&height=800&seq=topic-restaurant-05&orientation=landscape",
    heat: 468920,
    updateCount: 8,
    lastUpdate: "8小时前",
    tags: ["餐饮", "整改", "消费体验"],
    highlights: [
      "曝光内容主要涉及后厨流程与物品存放规范。",
      "店家在致歉声明中承认管理存在疏漏，并宣布暂停营业整改。",
      "讨论延伸到网红店的排队时间与实际体验是否匹配。",
    ],
    timeline: [
      { date: "09-03", title: "内容曝光", detail: "相关视频在社交平台快速传播。" },
      { date: "09-04", title: "店家致歉", detail: "餐厅发布声明并宣布暂停营业。" },
      { date: "09-06", title: "部门检查", detail: "市场监管部门表示已到场核查。" },
      { date: "09-09", title: "整改进行中", detail: "店家公布阶段性整改进度。" },
    ],
    relatedIds: ["livestream-return", "travel-blogger", "festival-ticket"],
  },
  {
    id: "dj-club-transfer",
    title: "电竞俱乐部转会风波",
    category: "电竞",
    status: "持续更新中",
    summary:
      "赛季结束后，多支电竞俱乐部围绕选手合同、转会费与青训权益产生争议，选手个人发展与俱乐部投入之间的平衡成为讨论焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20arena%20with%20warm%20amber%20glow%20and%20blurred%20screens%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20moody%20atmosphere&width=1200&height=800&seq=topic-esports-06&orientation=landscape",
    heat: 612540,
    updateCount: 11,
    lastUpdate: "3小时前",
    tags: ["电竞", "转会", "青训"],
    highlights: [
      "转会费与合同年限成为双方谈判的主要分歧。",
      "青训选手的权益保障被反复提及。",
      "联盟方面表示将完善转会窗口的流程规范。",
    ],
    timeline: [
      { date: "08-25", title: "赛季结束", detail: "赛季收官，转会窗口开启。" },
      { date: "08-29", title: "转会传闻", detail: "多名选手的去向引发讨论。" },
      { date: "09-02", title: "合同争议", detail: "选手与俱乐部就合同细节产生分歧。" },
      { date: "09-05", title: "联盟介入", detail: "联盟称将规范转会流程。" },
      { date: "09-09", title: "持续跟进", detail: "多方仍在协商之中。" },
    ],
    relatedIds: ["xuanxiu-contract", "shorts-wage", "festival-ticket"],
  },
  {
    id: "scriptmurder-copy",
    title: "剧本杀内容抄袭争议",
    category: "文娱",
    status: "已平息",
    summary:
      "两部热门剧本被指情节高度相似，原作者与发行方就创作来源各执一词，剧本行业的版权保护话题再次被提起。",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20books%20and%20warm%20desk%20lamp%20on%20dark%20wooden%20table%2C%20editorial%20still%20life%20photography%2C%20amber%20tones%2C%20no%20people&width=1200&height=800&seq=topic-script-07&orientation=landscape",
    heat: 392110,
    updateCount: 5,
    lastUpdate: "2天前",
    tags: ["剧本杀", "版权", "创作"],
    highlights: [
      "争议集中在核心诡计与人物关系设定是否构成实质性相似。",
      "作者表示将通过法律途径维护权益。",
      "行业内呼吁建立更透明的剧本备案机制。",
    ],
    timeline: [
      { date: "08-15", title: "对比帖出现", detail: "网友整理两部剧本的相似情节。" },
      { date: "08-18", title: "发行方回应", detail: "发行方称创作过程独立。" },
      { date: "08-22", title: "作者表态", detail: "原作者表示将采取法律手段。" },
      { date: "08-26", title: "逐渐平息", detail: "双方进入取证阶段，舆论降温。" },
    ],
    relatedIds: ["shorts-wage", "xuanxiu-contract", "dj-club-transfer"],
  },
  {
    id: "travel-blogger",
    title: "旅行博主内容翻车",
    category: "自媒体",
    status: "持续更新中",
    summary:
      "一位长期分享旅行攻略的博主被指部分内容为摆拍与旧素材拼接，粉丝对攻略真实性的信任受到冲击，平台也更新了内容标注要求。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20mountain%20vista%20at%20sunset%20with%20warm%20amber%20sky%20and%20haze%2C%20abstract%20editorial%20landscape%20photography%2C%20no%20people&width=1200&height=800&seq=topic-travel-08&orientation=landscape",
    heat: 448870,
    updateCount: 7,
    lastUpdate: "5小时前",
    tags: ["自媒体", "摆拍", "内容真实"],
    highlights: [
      "被指使用的部分画面与发布时间线存在出入。",
      "博主回应称内容为个人记录，不构成商业承诺。",
      "平台更新规则，要求对素材来源进行标注。",
    ],
    timeline: [
      { date: "09-02", title: "质疑出现", detail: "粉丝比对素材后发现疑点。" },
      { date: "09-04", title: "博主回应", detail: "博主发布长文解释素材来源。" },
      { date: "09-07", title: "平台更新", detail: "平台更新内容标注相关规则。" },
      { date: "09-09", title: "持续讨论", detail: "关于攻略真实性的讨论仍在继续。" },
    ],
    relatedIds: ["restaurant-safety", "livestream-return", "festival-ticket"],
  },
];